/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
  // In-App Notification
  LOAD_INAPP_NOTIFICATION_SUCCESS,
  LOAD_INAPP_NOTIFICATION_ERROR,
  CREATE_INAPP_NOTIFICATION_SUCCESS,
  CREATE_INAPP_NOTIFICATION_ERROR,
  UPDATE_INAPP_NOTIFICATION_SUCCESS,
  UPDATE_INAPP_NOTIFICATION_ERROR,
  DELETE_INAPP_NOTIFICATION_SUCCESS,
  DELETE_INAPP_NOTIFICATION_ERROR,

  // Push Notification
  LOAD_PUSH_NOTIFICATION_SUCCESS,
  LOAD_PUSH_NOTIFICATION_ERROR,
  CREATE_PUSH_NOTIFICATION_SUCCESS,
  CREATE_PUSH_NOTIFICATION_ERROR,
  UPDATE_PUSH_NOTIFICATION_SUCCESS,
  UPDATE_PUSH_NOTIFICATION_ERROR,
  DELETE_PUSH_NOTIFICATION_SUCCESS,
  DELETE_PUSH_NOTIFICATION_ERROR,
  LOAD_NOTIFY_RECORDS_META_DATA_SUCCESS,
  LOAD_NOTIFY_RECORDS_META_DATA_ERROR,
} from "./constants";

const initialState = {
  // In-App Notification
  notification_list: [],
  inAppNotificationRecord: {},
  recordsMetaData: {},
  // Push Notification
  pushNotification_list: [],
  pushNotificationRecord: {},

  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  {
    type,
    notification_list,
    record,
    error,
    success,
    recordsMetaData,
    pushNotification_list
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      /* -------------------- In-App Notification -------------------- */
      case LOAD_INAPP_NOTIFICATION_SUCCESS:
        draft.notification_list = notification_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_NOTIFY_RECORDS_META_DATA_SUCCESS:
        draft.recordsMetaData = recordsMetaData;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_INAPP_NOTIFICATION_SUCCESS:
        draft.inAppNotificationRecord = [record].concat(state.inAppNotificationRecord);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_INAPP_NOTIFICATION_SUCCESS:
        draft.inAppNotificationRecord = [record].concat(state.inAppNotificationRecord);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_INAPP_NOTIFICATION_SUCCESS:
        draft.inAppNotificationRecord = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_NOTIFY_RECORDS_META_DATA_ERROR:
      case LOAD_INAPP_NOTIFICATION_ERROR:
      case CREATE_INAPP_NOTIFICATION_ERROR:
      case UPDATE_INAPP_NOTIFICATION_ERROR:
      case DELETE_INAPP_NOTIFICATION_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      /* -------------------- Push Notification -------------------- */
      case LOAD_PUSH_NOTIFICATION_SUCCESS:
        draft.pushNotification_list = pushNotification_list;
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
      case CREATE_PUSH_NOTIFICATION_SUCCESS:
        draft.pushNotificationRecord = [record].concat(state.pushNotificationRecord);
        draft.loading = false;
        draft.error = false;
        draft.success = success;
        break;
      case UPDATE_PUSH_NOTIFICATION_SUCCESS:
        draft.pushNotificationRecord = [record].concat(state.pushNotificationRecord);
        draft.error = false;
        draft.success = success;
        break;
      case DELETE_PUSH_NOTIFICATION_SUCCESS:
        draft.pushNotificationRecord = record;
        draft.error = false;
        draft.success = success;
        break;

      case LOAD_PUSH_NOTIFICATION_ERROR:
      case CREATE_PUSH_NOTIFICATION_ERROR:
      case UPDATE_PUSH_NOTIFICATION_ERROR:
      case DELETE_PUSH_NOTIFICATION_ERROR:
        draft.loading = false;
        draft.error = error;
        draft.success = false;
        break;

      default:
        return state;
    }
  });
};

export default Reducer;
